import { css } from 'styled-components';

/* TappableArea */
/* The defined/ minimum tappable area for accessibility */
const StyledTappableArea = css`
	/* invisible pseudo element to make the tappable area on buttons at least 44x44px */
	&:after {
		content: '';
		display: block;
		min-height: 44px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		min-width: 44px;
		width: 100%;
	}
`;

export { StyledTappableArea as TappableArea };

export default StyledTappableArea;
